import { useMutation } from "@apollo/client";
import { Form } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import {
  CREATE_OPTION,
  UPDATE_OPTION,
} from "../../../../graphql/mutations/management";
import { GET_BET_OPTION_LIST } from "../../../../graphql/queries/asset";
import CustomFormGroup from "../../../../components/form/CustomFormGroup";
import {
  clearFormOption,
  onChangeOptionForm,
  toggleOptionModal,
} from "../../redux/betOptionSlice";
import SubmitButton from "../../../../components/common/SubmitButton";

const OptionForm = () => {
  const dispatch = useDispatch();
  const { optionCreateForm, optionUpdateForm, isEdit } = useSelector(
    (state) => state.betOption,
  );

  const [createOption, { loading }] = useMutation(CREATE_OPTION, {
    refetchQueries: [{ query: GET_BET_OPTION_LIST }],
    onCompleted: (data) => {
      if (data.createOption) {
        dispatch(toggleOptionModal());
        dispatch(clearFormOption());
        toast.success("ສຳເລັດ", {
          position: "top-center",
          className: "lao",
        });
      }
    },
    onError(err) {
      toast.error(`ບໍ່ສຳເລັດ ${err}`, {
        position: "top-center",
        className: "lao",
      });
    },
  });

  const [updateOption, { loading: updateLoading }] = useMutation(
    UPDATE_OPTION,
    {
      refetchQueries: [{ query: GET_BET_OPTION_LIST }],
      onCompleted: (data) => {
        if (data.updateOption) {
          dispatch(toggleOptionModal());
          dispatch(clearFormOption());
          toast.success("ສຳເລັດ", {
            position: "top-center",
            className: "lao",
          });
        }
      },
      onError(err) {
        toast.error(`ບໍ່ສຳເລັດ ${err}`, {
          position: "top-center",
          className: "lao",
        });
      },
    },
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    isEdit
      ? updateOption({
          variables: {
            id: optionUpdateForm.id,
            input: {
              name: optionUpdateForm.name,
              engName: optionUpdateForm.engName,
              profit: optionUpdateForm.profit,
              isHaveProfit: optionUpdateForm.isHaveProfit,
            },
          },
        })
      : createOption({
          variables: {
            input: optionCreateForm,
          },
        });
  };

  const handleChange = (e) => {
    if (isEdit) {
      dispatch(
        onChangeOptionForm({
          ...optionUpdateForm,
          [e.target.name]:
            e.target.type === "number"
              ? parseFloat(e.target.value)
              : e.target.value,
        }),
      );
    } else {
      dispatch(
        onChangeOptionForm({
          ...optionCreateForm,
          [e.target.name]:
            e.target.type === "number"
              ? parseFloat(e.target.value)
              : e.target.value,
        }),
      );
    }
  };

  const isLoading = isEdit ? updateLoading : loading;

  return (
    <Form className="notolao" onSubmit={handleSubmit}>
      <CustomFormGroup
        label="ຊື່"
        name="name"
        onChange={handleChange}
        type="text"
        value={isEdit ? optionUpdateForm.name : optionCreateForm?.name}
        required={true}
      />
      <CustomFormGroup
        label="ຊື່ອັງກິດ"
        name="engName"
        onChange={handleChange}
        type="text"
        value={isEdit ? optionUpdateForm.engName : optionCreateForm.engName}
        required={true}
      />
      <CustomFormGroup
        label="ກຳໄລ"
        name="profit"
        onChange={handleChange}
        type="number"
        value={isEdit ? optionUpdateForm.profit : optionCreateForm?.profit}
      />

      <div className="text-center">
        <SubmitButton loading={isLoading} />
      </div>
    </Form>
  );
};

export default OptionForm;
